import React from 'react';
import { Alert } from 'antd';
import { ResultComponentProps } from '../../common/types';
import AminoAcidConversionTable from './AminoAcidConversionTable';

// 氨基酸序列互转结果展示组件
const AminoAcidConversionResult: React.FC<ResultComponentProps> = ({ data, title }) => {
  if (!data) {
    return <Alert message="没有数据" type="warning" />;
  }

  const normalizedResults = React.useMemo(() => {
    if (data && data.results && Array.isArray(data.results)) {
      if (data.results.length === 1 && Array.isArray(data.results[0]?.result?.results)) {
        return data.results[0].result.results;
      }
      return data.results;
    }
    if (Array.isArray(data)) {
      return data;
    }
    return [] as any[];
  }, [data]);

  if (normalizedResults.length > 0) {
    return (
      <AminoAcidConversionTable
        conversionResults={normalizedResults}
        totalSequences={data.total_sequences || normalizedResults.length}
        successfulCount={data.successful_count || normalizedResults.filter((item: any) => item.success !== false).length}
        failedCount={data.failed_count || normalizedResults.filter((item: any) => item.success === false).length}
      />
    );
  }

  if (!data.original_sequence || !data.converted_sequence) {
    return <Alert message="数据格式不正确" type="warning" />;
  }

  const mockResults = [{
    sequence_id: "1",
    sequence: data.original_sequence,
    success: true,
    result: {
      original_sequence: data.original_sequence,
      converted_sequence: data.converted_sequence,
      conversion_type: data.original_format === "1字母" ? "1to3" : "3to1",
      sequence_length: data.original_sequence.length
    }
  }];

  return (
    <AminoAcidConversionTable
      conversionResults={mockResults}
      totalSequences={1}
      successfulCount={1}
      failedCount={0}
    />
  );
};

export default AminoAcidConversionResult;